import { render } from "./DocumentListItem.vue?vue&type=template&id=20456a08&scoped=true"
import script from "./DocumentListItem.vue?vue&type=script&lang=ts"
export * from "./DocumentListItem.vue?vue&type=script&lang=ts"

import "./DocumentListItem.vue?vue&type=style&index=0&id=20456a08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20456a08"

export default script